export const createAction =
	(type, withAuth = true) =>
	(payload) => ({ type, payload, withAuth });
